import { render, staticRenderFns } from "./editContactUs.vue?vue&type=template&id=42b99cb2"
import script from "./editContactUs.vue?vue&type=script&lang=js"
export * from "./editContactUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports